import {Pipe, PipeTransform} from '@angular/core';
import {DateTime} from 'luxon'
import {TranslateService} from '@ngx-translate/core';
import {CookieService} from "@/app/services/cookie.service";
import {getTzAbbrOrFallback} from "@/app/common/common";

type Referential = 'relative' | 'absolute';

@Pipe({
    name: 'eventWindow'
})
export class EventWindowPipe implements PipeTransform {

    locale: string;

    constructor(private translateService: TranslateService, private cookieService: CookieService) {
    }

    transform(start: any, end: any, timezone: string, tzShort: string, referential: Referential): string {
        this.locale = this.cookieService.getI18NLocale();
        if (!!timezone && !!this.locale) {

            if (!end) {
                return this.translateService.instant('DISPATCH_LIST.PORTFOLIO_CARD.WINDOW.START', {
                    date: this.getDayLabel(start, timezone, this.locale, referential),
                    start: DateTime.fromISO(start).setZone(timezone).setLocale(this.locale).toLocaleString(DateTime.TIME_SIMPLE),
                    timezone: this.getTimezoneLabel(start, timezone)
                })
            } else {
                const startTz = this.getTimezoneLabel(start, timezone);
                const endTz = this.getTimezoneLabel(end, timezone);
                const startTime = DateTime.fromISO(start).setZone(timezone).setLocale(this.locale).toLocaleString(DateTime.TIME_SIMPLE);
                return this.translateService.instant('DISPATCH_LIST.PORTFOLIO_CARD.WINDOW.BOTH', {
                    date: this.getDayLabel(start, timezone, this.locale, referential),
                    end: DateTime.fromISO(end).setZone(timezone).setLocale(this.locale).toLocaleString(DateTime.TIME_SIMPLE),
                    start: startTz === endTz ? startTime : `${startTime} ${startTz}`,
                    timezone: endTz
                })
            }
        }
        return ''
    }

    getTimezoneLabel(dttm: string, timezone: string): string {
        const localDate = DateTime.fromISO(dttm).setZone(timezone);
        return getTzAbbrOrFallback(timezone, localDate.toJSDate(), localDate.setLocale('en-us').toFormat('ZZZZ'));
    }

    getDayLabel(dttm: string, timezone: string, locale: string, referential: Referential): string {
        if (!!timezone) {
            const localDate = DateTime.fromISO(dttm).setZone(timezone);
            if (referential === 'absolute') {
                return localDate.setLocale(locale).toFormat('DD');
            } else {
                const relativeYesterday = DateTime.now().minus({days: 1}).startOf('day').setZone(timezone);
                const relativeToday = DateTime.now().startOf('day').setZone(timezone);
                const relativeTomorrow = DateTime.now().plus({days: 1}).startOf('day').setZone(timezone);
                const afterThat = DateTime.now().plus({days: 2}).startOf('day').setZone(timezone);

                if (localDate < relativeToday) {
                    return this.translateService.instant('DAYS.YESTERDAY');
                } else if (localDate > relativeToday && localDate < relativeTomorrow) {
                    return this.translateService.instant('DAYS.TODAY');
                } else if (localDate > relativeTomorrow && localDate < afterThat) {
                    return this.translateService.instant('DAYS.TOMORROW');
                } else {
                    return localDate.setLocale(locale).toFormat('DD');
                }
            }
        }
        return ''
    }
}
